// protected.js
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; 

const Protected = () => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <Outlet /> : <Navigate to="/home" />;
};

export default Protected;
